import React from 'react';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
import Column from '../layout/Column';
const HistoryItemCard = ({ ...columnProps }) => {
    const [{ theme }] = useTheme(stylesGenerator);
    return (React.createElement(Column, { bg: theme.palette.background.subtle, brd: theme.borderRadius.standard.xxl, ph: theme.spacing.standard.lg, pv: theme.spacing.standard.lg, ...columnProps }));
};
const stylesGenerator = createThemedStyle(({}) => ({}));
export default HistoryItemCard;
